<template>
  <v-col cols="12">
    <v-row no-gutters align="center">
      <span class="title">Groups</span>
      <v-spacer></v-spacer>
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            color="primary"
            icon
            outlined
            v-bind="attrs"
            v-on="on"
            @click="add"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Create new group</span>
      </v-tooltip>
    </v-row>

    <v-divider class="my-1"></v-divider>

    <v-data-table
      :headers="headers"
      :items="groups"
      class="elevation-1"
      hide-default-footer
      dense
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-for="(item, idx) in items" :key="idx">
            <td>{{ item.name }}</td>
            <td class="text-end">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    icon
                    small
                  >
                    <v-icon>mdi-cog</v-icon>
                  </v-btn>
                </template>
                <v-list dense class="ma-0 pa-0">
                  <v-list-item @click="edit(item)">
                    <v-row no-gutters>
                      <v-icon small color="primary" class="mr-2"
                        >mdi-pencil</v-icon
                      >
                      <span class="caption">Edit</span>
                    </v-row>
                  </v-list-item>
                  <v-list-item @click="promptDelete(item, idx)">
                    <v-row no-gutters>
                      <v-icon small color="error" class="mr-2"
                        >mdi-delete</v-icon
                      >
                      <span class="caption">Delete</span>
                    </v-row>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>

    <confirmation-dialog ref="confirmation" />
  </v-col>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      headers: [
        {
          text: "Name",
          value: "name",
        },
        {
          text: "Actions",
          align: "end",
        },
      ],
      groups: [],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      let self = this;

      self.get(`Group/GetAll`).then((r) => {
        if (r.data.success) {
          self.groups = r.data.data;
        }
      });
    },
    add() {
      this.$router.push(`/Group/Maintenance/-1`);
    },
    cancel() {
      let self = this;

      self.show = false;
      self.$refs.form.reset();
    },
    edit(item) {
      this.$router.push(`/Group/Maintenance/${item.id}`);
    },
    promptDelete(item, idx) {
      let self = this;

      self.$refs.confirmation.showDialog({
        title: `Are you sure you want to delete ${item.name}?`,
        message: "This will remove the group",
        callback: self.handleDelete,
        callbackData: { item: item, idx: idx },
      });
    },
    handleDelete(data) {
      let self = this;

      self.delete(`Group?id=${data.item.id}`).then((r) => {
        if (r.data.success) {
          self.hierarchies.splice(data.idx, 1);
        }
      });
    },
  },
};
</script>

<style>
</style>